module.exports = __webpack_public_path__ + "static/img/coe-4ton-bluegrey.d874878.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/coe-4ton-bluegrey.svg
// module id = Cuzp
// module chunks = 74